let date = new Date();
let espDateNow = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
let c_month = "01";
if (date.getMonth() + 1 < 10) {
  c_month = "0" + (date.getMonth() + 1);
} else {
  c_month = "" + (date.getMonth() + 1);
}

let loadingType = {
  lock: true,
  text: "Loading",
  spinner: "el-icon-loading",
  background: "rgba(0, 0, 0, 0.3)"
};

export default {
  esp_page_size: 20,
  esp_page_size_group: [10, 20, 50, 100, 300, 500],
  loadingType: loadingType,
  esp_data_now: espDateNow
}



// WEBPACK FOOTER //
// ./src/utils/constant.js